import type {
    AuthenticationInformation,
    AuthenticationRequest,
    AuthenticationStatus,
    AuthenticationWithBackupcode,
    AuthenticationWithOtpRequest,
    SSOAuthenticationMethod,
} from '../../domain'

export type AuthenticationResponse = Pick<AuthenticationInformation, 'token' | 'expiresAt' | 'capabilities'>
export type SessionResponse = Pick<AuthenticationInformation, 'username' | 'expiresAt' | 'capabilities'>

export interface AuthenticationService {
    /**
     * Signals to the auth service that the given token is no longer going to be used
     */
    flushAuthentication(token: string): Promise<void>

    /**
     * Authenticates on the auth service
     * @throws {import('../../domain').ConnectwareError}
     * @throws {import('../../domain').MfaRequiredError}
     * @returns Either a response that the user is authenticated or a secret to be used along side an OTP
     */
    authenticate(request: AuthenticationRequest | AuthenticationWithOtpRequest | AuthenticationWithBackupcode): Promise<AuthenticationResponse>

    /**
     * Retrieves the given token's session
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchSession(token: string): Promise<SessionResponse>

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    fetchAuthenticationStatus(token: string): Promise<AuthenticationStatus>

    /**
     * Retrieves the active SSO types
     */
    fetchActiveSSOAuthenticationMethods(): Promise<readonly SSOAuthenticationMethod[]>

    /**
     * Retrieves the authentication URL for given SSO type
     */
    fetchSSOAuthenticationUrl(type: SSOAuthenticationMethod): Promise<URL>
}
